export default __webpack_public_path__ + "static/media/instagram.c3720fe6.svg";